// WHIT-493: the brand's pictures. Tipptour keeps its photos and ticket
// images; Allmyles uses the 3D illustrations from
// docs/brand/allmyles/HANDOFF.md (sections 6 and 6b). Each brand only
// renders, and so only downloads, its own.
import { IS_ALLMYLES } from 'utils/brand';
import ticketYes from 'assets/svgs/img-ticket-yes.svg';
import ticketX from 'assets/svgs/img-ticket-x.svg';
import click from 'assets/svgs/img-click.svg';
import travelSimple from 'assets/images/travel-simple.png';
import allmylesHero from './allmyles/hero.svg';
import allmylesPeople from './allmyles/people.svg';
import allmylesPaperPlane from './allmyles/paper-plane.svg';
import allmylesSuccess from './allmyles/success.svg';
import allmylesSupport from './allmyles/support.svg';

// The home page's cover on Allmyles (Tipptour's is a photo, in HomeCover).
export const heroIllustration = allmylesHero;
// Login and sign-up.
export const loginIllustration = IS_ALLMYLES ? allmylesPaperPlane : click;
// A booking or subscription that went through.
export const successIllustration = IS_ALLMYLES ? allmylesSuccess : ticketYes;
// One that did not, or needs the customer to act.
export const failureIllustration = IS_ALLMYLES ? allmylesSupport : ticketX;
// The home page's "travel simple" section.
export const travelSimpleIllustration = IS_ALLMYLES
  ? allmylesPeople
  : travelSimple;
